export function CoachPanel({ correct, taken, suggested, reason, title = null }) {
  return (
    <div className={`max-w-xl w-full rounded-lg border p-4 ${correct ? 'bg-emerald-900/40 border-emerald-400/40' : 'bg-rose-900/40 border-rose-400/50'}`}>
      <div className="flex items-center justify-between mb-1 gap-3">
        <span className="font-bold uppercase text-xs tracking-widest">
          {correct ? '✓ Correct' : '✗ Off-strategy'}
        </span>
        <span className="text-xs text-white/60">
          {title ? <b>{title}</b> : <>You: <b>{taken}</b> · Optimal: <b>{suggested}</b></>}
        </span>
      </div>
      <p className="text-sm text-white/85">{reason}</p>
    </div>
  );
}

export function HintPanel({ children, tone = 'info' }) {
  const tones = {
    info: 'bg-sky-900/40 border-sky-400/40',
    warn: 'bg-amber-900/40 border-amber-400/40',
    success: 'bg-emerald-900/40 border-emerald-400/40',
  };
  return (
    <div className={`max-w-xl w-full rounded-lg border p-4 ${tones[tone]}`}>
      <p className="text-sm text-white/85">{children}</p>
    </div>
  );
}
